export default __webpack_public_path__ + "static/media/storageUnit1-afterB-768w.402c30e4.avif";